import React from "react";
import styles from "./search.module.css";
import { useNavigate } from "react-router-dom";
import NotificationDropdown from "components/Notifications";
import MyAccount from "components/MyAccount";
import Search from "components/Search";

const SearchHeader = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.headerWrapper}>
      <div className={styles.header}>
        <img
          className={styles.flowIcon}
          onClick={() => navigate("/home")}
          src="/icons/flow_logoNew.svg"
          alt="flow"
          // src="/icons/flow.svg"
        />

        <Search />
        <div className={styles.userDetails}>
          <NotificationDropdown />

          <MyAccount />
        </div>
      </div>
    </div>
  );
};

export default React.memo(SearchHeader);
